
export const environment = {
    API_URL: '',
    LOCAL_STORAGE_TOKEN: "token",
    LOCAL_STORAGE_LANGUAGE : "lang",
};
